export default "__VITE_ASSET__DNomPeOZ__"